<template>
  <div class="content md journey-info" v-if="info">
    <div class="other-title">车辆信息</div>
    <detail-list :list="info.detailList"></detail-list>
    <div class="flex-box align-center" style="margin: 10px 0">
      <div class="other-title" style="margin-bottom: 0">接待人员信息</div>
      <person-picker
        multiple
        select-disable
        url="/activity/activity-receptionist"
        title="选择陪同人员"
        :value="info.receptionist || []"
        :query="`&filter[type]=3&filter[activity_id]=${info.activity_id}`"
        @change="receptionistSelect"
        style="margin-left: 10px">
        <a-button><a-icon type="plus-circle" />添加陪同人员</a-button>
      </person-picker>
    </div>
    <a-table row-key="id" :columns="receptionistColumns" :data-source="info.receptionist" size="small">
      <template v-slot:action="text, record">
        <a class="txt-btn danger" @click.stop="delReceptionist(record)">删除</a>
      </template>
    </a-table>
    <div class="flex-box align-center" style="margin: 10px 0">
      <div class="other-title" style="margin-bottom: 0">乘车人信息</div>
      <person-picker
        multiple
        select-disable
        url="/activity/activity-guest"
        title="选择乘车人"
        :value="info.vehicleAllocation ? info.vehicleAllocation.map(a => a.guest) : []"
        :query="`&filter[activity_id]=${info.activity_id}`"
        @change="guestSelect"
        style="margin-left: 10px">
        <a-button><a-icon type="plus-circle"/>添加乘车人</a-button>
      </person-picker>
    </div>
    <a-table row-key="id" :columns="guestColumns" :data-source="info.vehicleAllocation" size="small">
      <template v-slot:action="text, record">
        <a class="txt-btn danger" @click.stop="delGuest(record)">删除</a>
      </template>
    </a-table>
  </div>
</template>

<script>
    import DetailList from "../../../layouts/DetailList";
    import personPicker from "../../../components/form/person-picker";
    import {getDate} from "../../../common/js/tool";
    import {getVehicleTypeText} from "../../../common/activity/vehicle";
    export default {
        name: "ActivityJourney",
        components: {
            DetailList,
            personPicker
        },
        data() {
            return {
                info: null,
                receptionistColumns: [
                    {title: '姓名', dataIndex: 'name'},
                    {title: '手机号码', dataIndex: 'tel'},
                    {title: '操作', key: 'action', width: 180, scopedSlots: { customRender: 'action'}}
                ],
                guestColumns: [
                    {title: '姓名', dataIndex: 'name', customRender: (text, record) => record.guest ? record.guest.name: '--'},
                    {title: '手机号码', dataIndex: 'tel', customRender: (text, record) => record.guest ? record.guest.tel : '--'},
                    {title: '到达时间', dataIndex: 'arrival_time', customRender: (text, record) => record.guest ? record.guest.arrival_time : '--'},
                    {title: '接站地址', dataIndex: 'arrival_address', customRender: (text, record) => record.guest ? record.guest.arrival_address : '--'},
                    {title: '离开时间', dataIndex: 'leave_time', customRender: (text, record) => record.guest ? record.guest.leave_time : '--'},
                    {title: '送达地址', dataIndex: 'leave_address', customRender: (text, record) => record.guest ? record.guest.leave_address : '--'},
                    {title: '操作', key: 'action', width: 180, scopedSlots: { customRender: 'action'}}
                ]
            }
        },
        computed: {
            activity() {
                return this.$store.getters.activity;
            },
            journey() {
                return this.$route.params.journey;
            }
        },
        created() {
            this.getJourneyInfo();
        },
        methods: {
            delGuest(item) {
                this.$confirm({
                    title: "提示",
                    content: '确定删除此乘车人吗？',
                    onOk: () => {
                        const url = `/activity/activity-vehicle-allocation/${item.id}`;
                        this.$axios({
                            url,
                            method: 'DELETE'
                        }).then(this.getJourneyInfo);
                    },
                });
            },
            guestSelect(select) {
                const info = this.info;
                const url = '/activity/activity-vehicle-allocation/add-guest';
                const data = {
                    journey: info.id,
                    guest_id: select.map(s => s.id).join(","),
                }
                this.$axios({
                    url,
                    method: 'POST',
                    data
                }).then(res => {
                    if(res.error == 0) {
                        this.getJourneyInfo();
                    } else {
                        this.$message.warning(res.msg || '添加失败');
                    }
                })
            },
            delReceptionist(item) {
                this.$confirm({
                    title: "提示",
                    content: '确定删除此陪同人员吗？',
                    onOk: () => {
                        const info = this.info;
                        const ids = info.receptionist_id.split(",").map(Number);
                        const index = ids.indexOf(item.id);
                        if(index >= 0) {
                            ids.splice(index, 1);
                        }
                        this.updateJourney({
                            receptionist_id: ids.join(",")
                        });
                    },
                });
            },
            receptionistSelect(select) {
                const info = this.info;
                const receptionist = info.receptionist || [];
                const list = [...receptionist, ...select].map(item =>item.id);
                const ids = [...new Set(list)].join(",");
                this.updateJourney({
                    receptionist_id: ids
                });
            },
            updateJourney(data) {
                const url = `/activity/activity-vehicle-journey/${this.info.id}`;
                this.$axios({
                    url,
                    method: 'PATCH',
                    data
                }).then(() => {
                    this.getJourneyInfo();
                })
            },
            getJourneyInfo() {
                const journey = this.journey;
                const url = `/activity/activity-vehicle-journey/${journey}?expand=vehicleAllocation,receptionist,vehicle,driver`;
                this.$axios(url).then(res => {
                    this.dealJourney(res);
                });
            },
            dealJourney(info) {
                info.detailList = [
                    {label: '派车时间', value: `${getDate(info.start_time).pattern("yyyy-MM-dd HH:mm")} - ${getDate(info.end_time).pattern("yyyy-MM-dd HH:mm")}`},
                    {label: '座位信息', value: info.vehicle ? `${(info.receptionist || []).length + (info.vehicleAllocation || []).length + 1}/${info.vehicle.seats}` : '--'},
                    {label: '车牌号', value: info.vehicle ? info.vehicle.car_number : '--'},
                    {label: '车辆类型', value: info.vehicle ? getVehicleTypeText(info.vehicle.car_type) : '--'},
                    {label: '车牌品牌', value: info.vehicle ? info.vehicle.brand : '--'},
                    {label: '座位数', value: info.vehicle ? info.vehicle.seats : '--'},
                    {label: '司机姓名', value: info.driver ? info.driver.name : '--'},
                    {label: '司机手机号码', value: info.driver ? info.driver.tel : '--'},
                    {label: '车辆通行证', value: info.vehicle && info.vehicle.passCheck ? info.vehicle.passCheck.type : '未匹配'},
                ]
                this.info = info;
            }
        }
    }
</script>

<style scoped lang="less">
  .journey-info {
    overflow: auto;
  }
</style>
